import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { graphqlRequest } from '~/adapters/graphqlRequest';
import * as transformers from '../transformers';
import { Conversation, ConversationMessage, ConversationReaction } from '~/interfaces/conversation.interface';
import {
  AddConversationMessageDocument,
  AddConversationMessageMutationResult,
  GetConversationMessagesDocument,
  GetConversationsListDocument,
  UpdateReactionsDocument,
  UpdateReactionsMutationResult,
} from '~/gql/graphql';

// TODO: Maybe it would be easier to use the word "chat" instead of "conversations" to save some space?
const fetchConversationList = createAsyncThunk<Conversation[], number>(
  'conversations/fetchConversationList',
  async (languageId) => {
    const res = await graphqlRequest<any>(GetConversationsListDocument, { languageId });
    const conversationList = res.data?.conversationsList.map(transformers.conversationFrom);

    return conversationList;
  },
);

const fetchConversationMessages = createAsyncThunk<ConversationMessage[], number>(
  'conversations/fetchConversationMessages',
  async (conversationId) => {
    const res = await graphqlRequest<any>(GetConversationMessagesDocument, {
      conversationId,
    });
    const conversationsMessages = res.data?.conversationsMessages.map(transformers.conversationMessageFrom);

    return conversationsMessages;
  },
);

const updateConversationReaction = createAsyncThunk<
  ConversationReaction,
  { conversationId: number; like: boolean; greatIdea: boolean; workingOnIt: boolean }
>('conversations/updateConversationReaction', async ({ conversationId, like, greatIdea, workingOnIt }) => {
  const params = { conversationId, like, greatIdea, workingOnIt };
  const res = await graphqlRequest<UpdateReactionsMutationResult>(UpdateReactionsDocument, {
    conversationReaction: params,
  });
  const conversationReaction = transformers.conversationReactionFrom(res.data?.updateConversationReaction);

  return conversationReaction;
});

const addConversationMessage = createAsyncThunk<ConversationMessage, { conversationId: number; text: string }>(
  'conversations/addConversationMessage',
  // @ts-ignore @TODO Epic WT-21600
  async ({ conversationId, text }) => {
    const res = await graphqlRequest<AddConversationMessageMutationResult>(AddConversationMessageDocument, {
      conversationId,
      text,
    });
    const conversationMessage = transformers.conversationMessageFrom(res.data?.addConversationMessage);

    return conversationMessage;
  },
);

const resetConversationsPageErrors = createAction('conversations/resetConversationsPageErrors');

const resetConversationsPageStates = createAction('conversations/resetConversationsPageStates');

export const conversationsActions = {
  fetchConversationList,
  fetchConversationMessages,
  updateConversationReaction,
  addConversationMessage,
  resetConversationsPageErrors,
  resetConversationsPageStates,
};
